import React from 'react';
import Editor from '../containers/editor';

export default Editor;